import Dialog from './src/SpDialog.vue';
import { createVNode, isVNode, render } from 'vue';
import { nextTick } from '@vue/runtime-core';
import Message from '@/components/common/SpMessage';
const instances = [];
let seed = 1;
// oprt 0-cancle 1-confirm 2-close
const defaultCallback = (res) => {
    Message('res callback:' + res);
};
const Confirm = function (opts) {
    if (typeof opts === 'string') {
        opts = {
            content: opts
        };
    }
    const defaultOptions = {
        // toBody: true,
        type: 'confirm',
        callback: defaultCallback
        // width: 300,
        // direction: 'center',
        // center: true,
        // title: '提示'
    };
    let options = Object.assign(defaultOptions, opts);
    // let options = { ...defaultOptions, ...opts }
    const id = 'dialog-' + seed++;
    const userOnClose = options.results;
    let resolves;
    const result = new Promise((resolve, reject) => {
        resolves = resolve;
    });
    options = {
        ...options,
        onClose: (oprt) => {
            resolves(oprt);
            close(id, userOnClose);
            options.callback(2);
        },
        onConfirm: (oprt) => {
            resolves(oprt);
            close(id, userOnClose);
            options.callback(1);
        },
        onCancle: (oprt) => {
            resolves(oprt);
            close(id, userOnClose);
            options.callback(0);
        },
        id,
        zIndex: 10000
    };
    const container = document.createElement('div');
    container.className = `container_${id}`;
    const message = options.message;
    const vm = createVNode(Dialog, options, isVNode(options.message) ? { default: () => message } : null);
    vm.props.onDestroy = () => {
        render(null, container);
    };
    render(vm, container);
    instances.push({ vm });
    nextTick().then(() => {
        try {
            document.body.appendChild(container.firstElementChild);
        }
        catch (e) {
        }
    });
    return result;
};
export function close(id, userOnClose) {
    const idx = instances.findIndex(({ vm: vm2 }) => {
        const { id: _id } = vm2.component.props;
        return id === _id;
    });
    if (idx === -1) {
        return;
    }
    const { vm } = instances[idx];
    if (!vm) {
        return;
    }
    // eslint-disable-next-line no-void
    userOnClose == null ? void 0 : userOnClose(vm);
    instances.splice(idx, 1);
}
export function closeAll() {
    for (let i = instances.length - 1; i >= 0; i--) {
        const instance = instances[i].vm.component;
        instance.ctx.closePop();
    }
}
Dialog.Confirm = Confirm;
Dialog.closeAll = closeAll;
export default Dialog;
